import { CartItem } from './cart';
import { ErrorResponse } from './types';
import { IEntityCartItem } from '../reducers/cartSlice.props';

export const getErrorMessages = (errorResponse: ErrorResponse) => {
  return errorResponse.message;
};

export const getOrderErrorMessage = (cartItem: CartItem | IEntityCartItem) => {
  const hasOptions =
    ('childModifierGroups' in cartItem &&
      Object.values(cartItem.childModifierGroups).length) ||
    ('children' in cartItem && cartItem.children.length);
  return `Sorry, ${cartItem.name} ${
    hasOptions ? 'with selected options' : ''
  } isn't available right now. Would you like to choose something else?`;
};
